import { defineComponent as _defineComponent } from 'vue'
import { renderList as _renderList, Fragment as _Fragment, openBlock as _openBlock, createElementBlock as _createElementBlock, toDisplayString as _toDisplayString, createElementVNode as _createElementVNode, unref as _unref, withCtx as _withCtx, createBlock as _createBlock, createCommentVNode as _createCommentVNode, createTextVNode as _createTextVNode, createVNode as _createVNode, pushScopeId as _pushScopeId, popScopeId as _popScopeId } from "vue"

const _withScopeId = n => (_pushScopeId("data-v-1df0f113"),n=n(),_popScopeId(),n)
const _hoisted_1 = { class: "question-detail" }
const _hoisted_2 = { style: {"white-space":"nowrap","width":"30%"} }
const _hoisted_3 = { style: {"width":"70%"} }
const _hoisted_4 = ["onClick", "src"]
const _hoisted_5 = { style: {"margin-bottom":"5px"} }
const _hoisted_6 = { style: {"display":"flex","align-items":"center"} }
const _hoisted_7 = ["onClick", "src"]
const _hoisted_8 = { key: 0 }
const _hoisted_9 = ["onClick", "src"]
const _hoisted_10 = { key: 1 }
const _hoisted_11 = { key: 0 }
const _hoisted_12 = ["onClick", "src"]
const _hoisted_13 = { key: 1 }

import {
  BaseButton,
  BaseDescriptions,
  BaseDescriptionsItem
} from 'xrk-components';
import { QUESTION_TYPE } from '../../constants';
import { FILE_VIEW_URL } from '@/config';
import { BaseSvg } from '@/components/base/base-svg/index';

import { formatter } from '@/utils';


export default /*#__PURE__*/_defineComponent({
  __name: 'question-detail-5_20_21',
  props: {
    questionInfo: { default: () => ({}) },
    isShowMapHandleBtn: { type: Boolean, default: true }
  },
  emits: ['changeImgUrl', 'mapRefresh', 'diffMap'],
  setup(__props: any, { emit: __emit }) {


const emits = __emit;

const onChangeShowIndex = url => {
  emits('changeImgUrl', url);
};
const getTitle = (topic, index) => {
  // '1.此题为选择等级医院医生（点击编辑题干）[目标题](必填):';
  return `${index + 1}.${topic.label}[${QUESTION_TYPE[topic.topicType].label}]${
    topic.isMustFill ? '(必填)' : ''
  }`;
};

//文件预览
const onViewer = url => {
  window.open(`${FILE_VIEW_URL}?t=${Date.now()}&url=${url}`);
};

const onMapRefresh = () => {
  emits('mapRefresh');
};

const onDiffMap = () => {
  emits('diffMap');
};

const filterAnswers = ({ topicType, values }) => {
  if (!values || values.length === 0) {
    return '无';
  }
  if ([30].includes(topicType)) {
    return values.fullName || '无';
  }
  if ([1, 3, 19, 4, 17, 22].includes(topicType)) {
    return values || '无';
  }
  if ([14].includes(topicType)) {
    return formatter.date(values);
  }
  if ([15].includes(topicType)) {
    return formatter.date(values, 'YYYY-MM');
  }
  if ([2, 23, 26].includes(topicType)) {
    return values.join(',');
  }
  if ([24].includes(topicType)) {
    if (values.length === 0) {
      return '无';
    }
    return flattenArray(values)
      .map(item => item.label || '无')
      .join('/');
  }
  if (topicType === 25) {
    return values.map(item => item || '无').join('/');
  }
};
function flattenArray(arr) {
  return arr.flatMap(item => [item, ...flattenArray(item.children || [])]);
}

return (_ctx: any,_cache: any) => {
  return (_openBlock(), _createElementBlock("div", _hoisted_1, [
    (_openBlock(true), _createElementBlock(_Fragment, null, _renderList(_ctx.questionInfo, (topic, index) => {
      return (_openBlock(), _createBlock(_unref(BaseDescriptions), {
        key: index,
        title: getTitle(topic, index),
        column: 1,
        size: "large",
        direction: "vertical"
      }, {
        default: _withCtx(() => [
          (topic.topicType === -1)
            ? (_openBlock(), _createBlock(_unref(BaseDescriptionsItem), { key: 0 }, {
                default: _withCtx(() => [
                  (_openBlock(true), _createElementBlock(_Fragment, null, _renderList(topic.values, (answer) => {
                    return (_openBlock(), _createElementBlock("div", {
                      style: {"display":"flex","align-items":"center","border-bottom":"1px solid #e8e8e8","padding":"5px"},
                      key: answer.label
                    }, [
                      _createElementVNode("div", _hoisted_2, _toDisplayString(answer.label) + "： ", 1),
                      _createElementVNode("div", _hoisted_3, _toDisplayString(answer.values), 1)
                    ]))
                  }), 128))
                ]),
                _: 2
              }, 1024))
            : _createCommentVNode("", true),
          (topic.topicType === 31)
            ? (_openBlock(), _createBlock(_unref(BaseDescriptionsItem), { key: 1 }, {
                default: _withCtx(() => [
                  _createElementVNode("div", null, _toDisplayString(_unref(formatter).date(topic.values.startAt)) + "-" + _toDisplayString(_unref(formatter).date(topic.values.endAt)), 1)
                ]),
                _: 2
              }, 1024))
            : _createCommentVNode("", true),
          (topic.topicType === 29)
            ? (_openBlock(), _createBlock(_unref(BaseDescriptionsItem), { key: 2 }, {
                default: _withCtx(() => [
                  _createElementVNode("div", null, _toDisplayString(_unref(formatter).date(topic.values.startAt)), 1)
                ]),
                _: 2
              }, 1024))
            : _createCommentVNode("", true),
          (topic.topicType === -3)
            ? (_openBlock(), _createBlock(_unref(BaseDescriptionsItem), { key: 3 }, {
                default: _withCtx(() => [
                  _createElementVNode("img", {
                    onClick: ($event: any) => (onChangeShowIndex(topic.values)),
                    src: topic.values
                  }, null, 8, _hoisted_4),
                  _createVNode(_unref(BaseButton), {
                    style: {"margin-left":"5px"},
                    onClick: onDiffMap,
                    type: "primary"
                  }, {
                    default: _withCtx(() => [
                      _createTextVNode(" 对比地图 ")
                    ]),
                    _: 1
                  }),
                  (_ctx.isShowMapHandleBtn)
                    ? (_openBlock(), _createBlock(_unref(BaseButton), {
                        key: 0,
                        onClick: _cache[0] || (_cache[0] = ($event: any) => (onMapRefresh())),
                        type: "success"
                      }, {
                        default: _withCtx(() => [
                          _createTextVNode(" 更新地图 ")
                        ]),
                        _: 1
                      }))
                    : _createCommentVNode("", true)
                ]),
                _: 2
              }, 1024))
            : (
          [1, 2, 3, 14, 15, 19, 4, 22, 23, 24, 25, 30, 17, 26].includes(
            topic.topicType
          )
        )
              ? (_openBlock(), _createBlock(_unref(BaseDescriptionsItem), { key: 4 }, {
                  default: _withCtx(() => [
                    _createTextVNode(_toDisplayString(filterAnswers(topic)), 1)
                  ]),
                  _: 2
                }, 1024))
              : ([5].includes(topic.topicType))
                ? (_openBlock(true), _createElementBlock(_Fragment, { key: 5 }, _renderList(topic.optionJson, (option, index) => {
                    return (_openBlock(), _createBlock(_unref(BaseDescriptionsItem), {
                      key: option + index
                    }, {
                      default: _withCtx(() => [
                        _createElementVNode("div", _hoisted_5, _toDisplayString(option), 1),
                        _createElementVNode("div", null, _toDisplayString((topic.values && topic.values[index]) || '无'), 1)
                      ]),
                      _: 2
                    }, 1024))
                  }), 128))
                : ([6].includes(topic.topicType))
                  ? (_openBlock(), _createBlock(_unref(BaseDescriptionsItem), { key: 6 }, {
                      default: _withCtx(() => [
                        _createElementVNode("div", _hoisted_6, [
                          (_openBlock(), _createElementBlock(_Fragment, null, _renderList([1, 2, 3, 4, 5], (index) => {
                            return _createElementVNode("div", { key: index }, [
                              (index <= +topic.values)
                                ? (_openBlock(), _createBlock(_unref(BaseSvg), {
                                    key: 0,
                                    style: {"font-size":"18px"},
                                    iconClass: "wujiaoxing_cheng"
                                  }))
                                : (_openBlock(), _createBlock(_unref(BaseSvg), {
                                    key: 1,
                                    style: {"font-size":"18px"},
                                    iconClass: "wujiaoxing_hui"
                                  }))
                            ])
                          }), 64))
                        ])
                      ]),
                      _: 2
                    }, 1024))
                  : ([8, 9, 10, 11, 12].includes(topic.topicType))
                    ? (_openBlock(), _createElementBlock(_Fragment, { key: 7 }, [
                        (!topic.values)
                          ? (_openBlock(), _createBlock(_unref(BaseDescriptionsItem), { key: 0 }, {
                              default: _withCtx(() => [
                                _createTextVNode("无")
                              ]),
                              _: 1
                            }))
                          : (_openBlock(true), _createElementBlock(_Fragment, { key: 1 }, _renderList(topic.values, (value, index) => {
                              return (_openBlock(), _createBlock(_unref(BaseDescriptionsItem), {
                                key: value + index
                              }, {
                                default: _withCtx(() => [
                                  _createElementVNode("div", null, [
                                    _createVNode(_unref(BaseButton), {
                                      disabled: !value.url,
                                      onClick: ($event: any) => (onViewer(value.url)),
                                      type: "text"
                                    }, {
                                      default: _withCtx(() => [
                                        _createTextVNode(_toDisplayString(value.name || value.url || '无'), 1)
                                      ]),
                                      _: 2
                                    }, 1032, ["disabled", "onClick"])
                                  ])
                                ]),
                                _: 2
                              }, 1024))
                            }), 128))
                      ], 64))
                    : ([13].includes(topic.topicType))
                      ? (_openBlock(), _createElementBlock(_Fragment, { key: 8 }, [
                          (!topic.values)
                            ? (_openBlock(), _createBlock(_unref(BaseDescriptionsItem), { key: 0 }, {
                                default: _withCtx(() => [
                                  _createTextVNode("无")
                                ]),
                                _: 1
                              }))
                            : (_openBlock(), _createBlock(_unref(BaseDescriptionsItem), { key: 1 }, {
                                default: _withCtx(() => [
                                  (_openBlock(true), _createElementBlock(_Fragment, null, _renderList(topic.values, (value, index) => {
                                    return (_openBlock(), _createElementBlock("div", {
                                      key: value + index,
                                      style: {"display":"inline-block"}
                                    }, [
                                      _createElementVNode("img", {
                                        style: {"margin":"5px"},
                                        onClick: ($event: any) => (onChangeShowIndex(value.url)),
                                        src: value.url
                                      }, null, 8, _hoisted_7)
                                    ]))
                                  }), 128))
                                ]),
                                _: 2
                              }, 1024))
                        ], 64))
                      : ([20].includes(topic.topicType))
                        ? (_openBlock(), _createBlock(_unref(BaseDescriptionsItem), { key: 9 }, {
                            default: _withCtx(() => [
                              (topic.values)
                                ? (_openBlock(), _createElementBlock("div", _hoisted_8, [
                                    _createElementVNode("img", {
                                      onClick: ($event: any) => (onChangeShowIndex(topic.values)),
                                      src: topic.values
                                    }, null, 8, _hoisted_9)
                                  ]))
                                : (_openBlock(), _createElementBlock("div", _hoisted_10, "无"))
                            ]),
                            _: 2
                          }, 1024))
                        : ([16].includes(topic.topicType))
                          ? (_openBlock(), _createBlock(_unref(BaseDescriptionsItem), { key: 10 }, {
                              default: _withCtx(() => [
                                _createElementVNode("div", null, [
                                  (topic.values.addressPicUrl)
                                    ? (_openBlock(), _createElementBlock("div", _hoisted_11, [
                                        _createElementVNode("img", {
                                          onClick: ($event: any) => (onChangeShowIndex(topic.values.addressPicUrl)),
                                          src: topic.values.addressPicUrl
                                        }, null, 8, _hoisted_12),
                                        (_ctx.isShowMapHandleBtn)
                                          ? (_openBlock(), _createBlock(_unref(BaseButton), {
                                              key: 0,
                                              style: {"margin-left":"5px"},
                                              onClick: onDiffMap,
                                              type: "primary"
                                            }, {
                                              default: _withCtx(() => [
                                                _createTextVNode(" 对比地图 ")
                                              ]),
                                              _: 1
                                            }))
                                          : _createCommentVNode("", true),
                                        (_ctx.isShowMapHandleBtn)
                                          ? (_openBlock(), _createBlock(_unref(BaseButton), {
                                              key: 1,
                                              onClick: _cache[1] || (_cache[1] = ($event: any) => (onMapRefresh())),
                                              type: "success"
                                            }, {
                                              default: _withCtx(() => [
                                                _createTextVNode(" 更新地图 ")
                                              ]),
                                              _: 1
                                            }))
                                          : _createCommentVNode("", true)
                                      ]))
                                    : (_openBlock(), _createElementBlock("div", _hoisted_13, "无"))
                                ])
                              ]),
                              _: 2
                            }, 1024))
                          : ([18].includes(topic.topicType))
                            ? (_openBlock(), _createBlock(_unref(BaseDescriptionsItem), { key: 11 }))
                            : _createCommentVNode("", true),
          (topic.remark)
            ? (_openBlock(), _createBlock(_unref(BaseDescriptionsItem), {
                key: 12,
                label: `备注：${topic.remark}`
              }, null, 8, ["label"]))
            : _createCommentVNode("", true)
        ]),
        _: 2
      }, 1032, ["title"]))
    }), 128))
  ]))
}
}

})